export default __webpack_public_path__ + "assets/icons/ex.2c337287.svg";